import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Divider,
  Grid,
  CircularProgress,
  Typography,
  // IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import SelectField from "components/Select";
import { PrimaryButton } from "components/Buttons";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import Colors from "assets/Style/Colors";
import { v4 as uuidv4 } from "uuid";
import { FontFamily } from "assets";
import InputField from "components/Input";
import UploadFile from "components/UploadFile";
import DatePicker from "components/DatePicker";
import instance from "config/axios";
import routes from "services/System/routes";
import {
  CleanTypes,
  getFileSize,
  getStandardExchangeRate,
  normalizeExchangeRate,
} from "utils";
import styled from "@emotion/styled";
import { FiDownload } from "react-icons/fi";
// import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch } from "react-redux";
import { setUsdExchangeRate } from "redux/slices/navigationDataSlice";
import { useSelector } from "react-redux";
import FinanceServices from "services/Finance";
import { createRoot } from "react-dom/client";
import SystemServices from "services/System";
import FundTransferVoucherInvoice from "components/erp_invoices/iftVoucher";
import { useParams } from "react-router-dom";

const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "left",
    whiteSpace: "nowrap",
    backgroundColor: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "left",
    textWrap: "nowrap",

    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".css-1ru1j9e-MuiTableCell-root ": {
      color: "#ffffff",
      textAlign: "left",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const Input = styled("input")({
  position: "absolute",
  left: 0,
  top: 0,
  width: "100%",
  height: "100%",
  display: "block",
  opacity: 0,
  fontSize: 0,
  cursor: "pointer",
  zIndex: 1,
});

const HiddenInput = styled("input")({ display: "none" });

function UpdateIftv() {
  const viewerRef = useRef();
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
    getValues,
  } = useForm();

  const navigate = useNavigate();
  const { usdExchangeRate } = useSelector((state) => state.navigationReducer);
  const dispatch = useDispatch();
  useEffect(() => {
    const exchangeRate = 3.675;
    dispatch(setUsdExchangeRate(exchangeRate));
  }, []);

  const [loading, setLoading] = useState(false);

  // *For Accounts
  const [accounts, setAccounts] = useState([]);
  const [cashierAccounts, setCashierAccounts] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [voucherDetail, setVoucherDetail] = useState();

  const [walletAccounts, setWalletAccounts] = useState([]);
  const [vaultAccounts, setVaultAccounts] = useState([]);

  // *For Handle Date
  const [vaultDate, setVaultDate] = useState(new Date());

  // *For Exchange Rate Disabled
  const [disabledExchangeRate, setDisabledExchangeRate] = useState(true);
  const [exchangeRateUsd, setExchangeRateUsd] = useState(
    Number(usdExchangeRate || 0),
  );
  const [rcvAmountAed, setRcvAmountAed] = useState();

  // *For Updated Exchange Rate
  const [updateExchangeRate, setUpdateExchangeRate] = useState(usdExchangeRate);

  const getStandardUsdRate = () =>
    getStandardExchangeRate(exchangeRateUsd, usdExchangeRate);

  const syncExchangeRateValue = (value) => {
    const normalizedRate = normalizeExchangeRate(value, getStandardUsdRate());
    setUpdateExchangeRate(normalizedRate);
    setValue("exchangeRate", normalizedRate);
    return normalizedRate;
  };

  // *For Transfer Amount
  const [transferAmount, setTransferAmount] = useState();
  // *For Uploaded Documents
  const [progress, setProgress] = useState(0);
  const [uploadedSize, setUploadedSize] = useState(0);
  const [documentDetail, setDocumentDetail] = useState([]);
  const [documentLink, setDocumentLink] = useState("");

  const allowFilesTypeInvoice = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "application/pdf",
  ];

  const [selectedTransactionType, setSelectedTransactionType] = useState(null);
  const [selectedWalletType, setSelectedWalletType] = useState(null);
  const [selectedWalletTo, setSelectedWalletTo] = useState(null);
  const [selectedWalletFrom, setSelectedWalletFrom] = useState(null);
  const [selectedBankCashTo, setSelectedBankCashTo] = useState(null);
  const [selectedBankCashFrom, setSelectedBankCashFrom] = useState(null);

  const [filteredWalletFromAccounts, setFilteredWalletFromAccounts] = useState(
    [],
  );
  const [filteredWalletToAccounts, setFilteredWalletToAccounts] = useState([]);

  const [filteredFromAccounts, setFilteredFromAccounts] = useState([]);
  const [filteredToAccounts, setFilteredToAccounts] = useState([]);

  const [selectedBankCashType, setSelectedBankCashType] = useState(null);
  const [selectedBankCashType2, setSelectedBankCashType2] = useState(null);
  const [iftvDate, setIftvDate] = useState(new Date());
  const [attachmentType, setAttachmentType] = useState();

  const [invoiceList, setInvoiceList] = useState([]);

  const [loader, setLoader] = useState(false);

  const [selectedRate, setSelectedRate] = useState({ id: 3, name: "Auto" });

  const [documentDetail2, setDocumentDetail2] = useState([]);
  const [documentLink2, setDocumentLink2] = useState("");
  const [documentName, setDocumentName] = useState("");

  console.log(documentLink2, documentDetail2?.[0]?.name, "documentLink2");
  const [progress2, setProgress2] = useState(0);
  const [uploadedSize2, setUploadedSize2] = useState(0);
  // *For Upload File types
  const allowFilesType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "application/pdf",
  ];
  // *For Handle Date
  const handleVaultDate = (newDate) => {
    try {
      // eslint-disable-next-line eqeqeq
      if (newDate == "Invalid Date") {
        setVaultDate("invalid");
        return;
      }
      setVaultDate(new Date(newDate));
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getCurrencies = async () => {
    try {
      let params = {
        detailed: true,
      };
      const { data } = await SystemServices.getCurrencies(params);
      const usdRate = parseFloat(
        data?.currencies.find((currency) => currency.currency === "usd")
          ?.conversion_rate || 0,
      );

      setExchangeRateUsd(usdRate);
      setUpdateExchangeRate(usdRate);
      setValue("exchangeRate", usdRate);
      dispatch(setUsdExchangeRate(usdRate));
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    getCurrencies();
  }, []);

  // *For Get Payment Accounts
  const getPaymentAccounts = async (search) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        name: search,
      };
      const { data } = await FinanceServices.getPaymentAccounts(params);
      setAccounts([
        ...data?.cashierAccounts?.rows.filter(
          (account) =>
            account?.currency === "aed" || account?.currency === "usd",
        ),
        ...data?.bankAccounts?.rows.filter((account) => account?.currency),
      ]);

      setCashierAccounts(
        data?.cashierAccounts?.rows.map((account) => ({
          id: account.id,
          name: account.name,
          currency: account?.currency,
        })),
      );
      setBankAccounts(
        data?.bankAccounts?.rows.map((account) => ({
          id: account.id,
          name: account.name,
          currency: account?.currency,
        })),
      );
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getVaultCustomers = async () => {
    try {
      let params = {
        page: 1,
        limit: 1500,
      };
      const { data } = await FinanceServices.getVaultCustomers(params);

      const customers = data?.customers?.rows || [];

      // Merge all customer accounts into one array
      const allAccounts = customers.reduce((acc, customer) => {
        if (customer?.accounts?.length) {
          return [...acc, ...customer.accounts];
        }
        return acc;
      }, []);

      console.log(allAccounts, "vault");

      // Set the merged accounts to state
      setWalletAccounts(allAccounts);
      setVaultAccounts(
        allAccounts.map((account) => ({
          id: account.id,
          name: account.name,
        })),
      );
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    getPaymentAccounts();
    getVaultCustomers();
    getFundTransferVoucherDetail();
  }, []);

  useEffect(() => {
    const filterAccounts = () => {
      if (selectedBankCashType && selectedBankCashType2) {
        const fromAccounts = [];
        const toAccounts = [];

        switch (selectedBankCashType.id) {
          case "bank guc":
            fromAccounts.push(
              ...bankAccounts.filter((account) =>
                account.name.toLowerCase().startsWith("guc"),
              ),
            );
            break;
          case "cash guc":
            fromAccounts.push(
              ...cashierAccounts.filter((account) =>
                account.name.toLowerCase().startsWith("guc"),
              ),
            );
            break;
          case "bank gws":
            fromAccounts.push(
              ...bankAccounts.filter((account) =>
                account.name.toLowerCase().startsWith("gws"),
              ),
            );
            break;
          case "cash gws":
            fromAccounts.push(
              ...cashierAccounts.filter((account) =>
                account.name.toLowerCase().startsWith("gws"),
              ),
            );
            break;
          default:
            break;
        }

        switch (selectedBankCashType2.id) {
          case "bank guc":
            toAccounts.push(
              ...bankAccounts.filter((account) =>
                account.name.toLowerCase().startsWith("guc"),
              ),
            );
            break;
          case "cash guc":
            toAccounts.push(
              ...cashierAccounts.filter((account) =>
                account.name.toLowerCase().startsWith("guc"),
              ),
            );
            break;
          case "bank gws":
            toAccounts.push(
              ...bankAccounts.filter((account) =>
                account.name.toLowerCase().startsWith("gws"),
              ),
            );
            break;
          case "cash gws":
            toAccounts.push(
              ...cashierAccounts.filter((account) =>
                account.name.toLowerCase().startsWith("gws"),
              ),
            );
            break;
          default:
            break;
        }

        setFilteredFromAccounts(fromAccounts);
        setFilteredToAccounts(toAccounts);
      }
    };

    filterAccounts();
  }, [
    selectedBankCashType,
    selectedBankCashType2,
    bankAccounts,
    cashierAccounts,
  ]);

  useEffect(() => {
    if (!transferAmount) return;
    if (selectedTransactionType?.id !== "cash/bank") return;

    const amount = Number(transferAmount) || 0;
    const officialAedPerUsd = Number(exchangeRateUsd) || 0;
    const enteredRate = normalizeExchangeRate(
      updateExchangeRate,
      getStandardUsdRate(),
    );
    const fromCurrency = selectedBankCashFrom?.currency?.toLowerCase?.();
    const toCurrency = selectedBankCashTo?.currency?.toLowerCase?.();
    const isSameCurrency =
      Boolean(fromCurrency) &&
      Boolean(toCurrency) &&
      fromCurrency === toCurrency;

    setDisabledExchangeRate(isSameCurrency);

    const formatZeroSafe = (value, decimals) => {
      const n = Number(value) || 0;
      const eps = decimals === 2 ? 0.005 : 0.0005;
      if (Math.abs(n) < eps) return Number(0).toFixed(decimals);
      return n.toFixed(decimals);
    };

    if (isSameCurrency) {
      const receivedAmountAed =
        fromCurrency === "usd"
          ? amount * officialAedPerUsd
          : fromCurrency === "aed"
            ? amount
            : 0;
      setValue("receivedAmount", Number(amount || 0).toFixed(2), 0);
      setValue("receivedAmountAed", Number(receivedAmountAed || 0).toFixed(2), {
        shouldDirty: false,
        shouldValidate: false,
      });
      setValue("exchangeLoss", "0.00");
      return;
    }

    const isUsdToAed = fromCurrency === "usd" && toCurrency === "aed";
    const isAedToUsd = fromCurrency === "aed" && toCurrency === "usd";

    if (!isUsdToAed && !isAedToUsd) {
      setValue("receivedAmount", "0.00");
      setValue("receivedAmountAed", "0.00", {
        shouldDirty: false,
        shouldValidate: false,
      });
      setValue("exchangeLoss", "0.00");
      return;
    }

    if (isUsdToAed) {
      const receivedAed =
        enteredRate >= 1 ? amount * enteredRate : amount / enteredRate;
      const officialAedValue = amount * officialAedPerUsd;
      const exchangeLossAed = officialAedValue - receivedAed;

      setValue("receivedAmount", Number(receivedAed || 0).toFixed(2));
      setValue("receivedAmountAed", Number(receivedAed || 0).toFixed(2), {
        shouldDirty: false,
        shouldValidate: false,
      });
      setValue("exchangeLoss", formatZeroSafe(exchangeLossAed, 2));
      return;
    }

    // AED -> USD
    const enteredAedPerUsd = enteredRate >= 1 ? enteredRate : 1 / enteredRate;
    const officialUsdRaw =
      officialAedPerUsd > 0 ? amount / officialAedPerUsd : 0;
    const officialUsd = Number(Number(officialUsdRaw || 0).toFixed(2));
    const rateRatio =
      officialAedPerUsd > 0 ? enteredAedPerUsd / officialAedPerUsd : 0;

    const receivedUsd = officialAedPerUsd > 0 ? officialUsd * rateRatio : 0;
    const receivedAedAtOfficial = amount * rateRatio;
    const exchangeLossAed = amount - receivedAedAtOfficial;

    setValue("receivedAmount", Number(receivedUsd || 0).toFixed(2));
    setValue(
      "receivedAmountAed",
      Number(receivedAedAtOfficial || 0).toFixed(2),
      {
        shouldDirty: false,
        shouldValidate: false,
      },
    );
    setValue("exchangeLoss", formatZeroSafe(exchangeLossAed, 2));
  }, [
    transferAmount,
    updateExchangeRate,
    exchangeRateUsd,
    selectedTransactionType,
    selectedBankCashTo,
    selectedBankCashFrom,
  ]);

  const handleIftvDate = (newDate) => {
    try {
      if (newDate == "Invalid Date") {
        setIftvDate("invalid");
        return;
      }
      setIftvDate(new Date(newDate));
      setValue("iftvDate", newDate);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleUploadDocumentInvoices = async (e) => {
    try {
      e.preventDefault();
      const file = e.target.files[0];
      let arr = [
        {
          id: uuidv4(),
          name: file?.name,
          file: "",
          type: file?.type.split("/")[1],
          size: getFileSize(file.size),
          isUpload: false,
        },
      ];
      if (allowFilesTypeInvoice.includes(file.type)) {
        setDocumentDetail2(arr);
        handleUploadInvoices(file, arr);
      } else {
        ErrorToaster(
          `Only ${CleanTypes(allowFilesTypeInvoice)} formats is supported`,
        );
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleUploadInvoices = async (file, docs) => {
    setProgress(0);
    try {
      const formData = new FormData();
      formData.append("document", file);
      const { data } = await instance.post(routes.uploadDocuments, formData, {
        onUploadProgress: (progressEvent) => {
          const uploadedBytes = progressEvent.loaded;
          const percentCompleted = Math.round(
            (uploadedBytes * 100) / progressEvent.total,
          );

          setProgress2(percentCompleted);
          setUploadedSize2(getFileSize(uploadedBytes));
        },
      });
      if (data) {
        docs[0].isUpload = true;
        docs[0].file = data?.data?.nations;
        setDocumentDetail2(docs);
        setDocumentLink2(data?.data?.nations);
        SuccessToaster("Document Uploaded");
      } else {
        ErrorToaster("Document upload failed.");
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  console.log(invoiceList, "invoice");

  // const handleAddDocument = () => {

  //     if (!documentLink2) {
  //         ErrorToaster("Please upload a document before adding.");
  //         return;
  //     }

  //     setInvoiceList([
  //         ...invoiceList,
  //         {
  //             id: uuidv4(),
  //             attachmentType: attachmentType?.id,
  //             attachmentTypeName: documentDetail2?.[0]?.name,
  //             documentLink2,
  //         },
  //     ]);
  //     SuccessToaster("Document Added")
  //     setAttachmentType([]);
  //     setDocumentLink2("");
  // };

  // useEffect(() => {
  //     if (documentLink2) {
  //         handleAddDocument();
  //     }
  // }, [documentLink2]);

  useEffect(() => {
    const amt = Number(transferAmount || 0);
    const aed = amt * 3.675;
    setValue("receivedAmountAed", Number(aed || 0).toFixed(2), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setRcvAmountAed(aed);
  }, [transferAmount, setValue]);

  const handleUploadInvoice = async (file, docs) => {
    setProgress(0);
    try {
      const formData = new FormData();
      formData.append("document", file);
      const { data } = await instance.post(routes.uploadDocuments, formData, {
        onUploadProgress: (progressEvent) => {
          const uploadedBytes = progressEvent.loaded;
          const percentCompleted = Math.round(
            (uploadedBytes * 100) / progressEvent.total,
          );

          setProgress(percentCompleted);
          setUploadedSize(getFileSize(uploadedBytes));
        },
      });
      if (data) {
        docs[0].isUpload = true;
        docs[0].file = data?.data?.nations;
        setDocumentDetail(docs);
        setDocumentLink(data?.data?.nations);
        SuccessToaster("Document Added");
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const downloadAllAttachments = async (documentLinks) => {
    if (!documentLinks || documentLinks.trim() === "") {
      ErrorToaster("No attachments available.");
      return;
    }

    const filePath = documentLinks.trim();
    const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${filePath}`;
    const fileExtension = filePath.split(".").pop();

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `attachment.${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl); // Cleanup
      SuccessToaster("Downloading attachment...");
    } catch (error) {
      console.error("Download failed", error);
      ErrorToaster("Failed to download attachment.");
    }
  };

  const handleDeleteDocument = (id) => {
    setInvoiceList((prev) => prev.filter((d) => d.id !== id));
  };

  // *For Get Fund Transfer Voucher Detail
  const getFundTransferVoucherDetail = async () => {
    setLoader(true);
    try {
      let params = {
        voucher_id: id,
      };
      const { data } =
        await FinanceServices.getFundTransferVoucherDetail(params);
      const fromCashType =
        data?.voucher?.from_cash_type || data?.voucher?.bank_cash_type;
      const toCashType =
        data?.voucher?.to_cash_type || data?.voucher?.cash_bank_type;

      const getCashTypeName = (cashType) => {
        if (cashType === "bank guc") return "Bank GUC";
        if (cashType === "bank gws") return "Bank GWS";
        if (cashType === "cash guc") return "Cash GUC";
        if (cashType === "cash gws") return "Cash GWS";
        return "";
      };

      setVoucherDetail(data.voucher);
      setValue("transType", data.voucher.transaction_type);
      setSelectedTransactionType({
        id: data.voucher.transaction_type,
        name:
          data.voucher.transaction_type === "wallet" ? "Wallet" : "Cash/Bank",
      });
      handleIftvDate(data?.voucher?.c_date);
      setValue("ref", data?.voucher?.ref_no);
      setValue("transferAmount", data?.voucher?.from_amount);
      setValue("receivedAmount", data?.voucher?.to_amount);
      setValue("receivedAmountAed", data?.voucher?.to_amount_aed || "");
      setRcvAmountAed(data?.voucher?.to_amount_aed || 0);
      setTransferAmount(data?.voucher?.from_amount || 0);
      setValue("exchangeRate", data?.voucher?.exchange_rate);
      setUpdateExchangeRate(data?.voucher?.exchange_rate || exchangeRateUsd);
      setValue("exchangeLoss", data?.voucher?.exchange_loss);
      setValue("note", data?.voucher?.notes);
      setValue("documentLink", data?.voucher?.document_link);
      setDocumentLink2(data?.voucher?.document_link);
      setDocumentName(data?.voucher?.document_name);
      setSelectedBankCashFrom({
        id: data?.voucher?.from_account?.id,
        name: data?.voucher?.from_account?.name,
        currency: data?.voucher?.from_account?.currency,
      });
      setValue("bankType2", toCashType);
      setValue("bankType", fromCashType);
      setSelectedBankCashTo({
        id: data?.voucher?.to_account?.id,
        name: data?.voucher?.to_account?.name,
        currency: data?.voucher?.to_account?.currency,
      });
      setSelectedWalletTo({
        id: data?.voucher?.to_account?.id,
        name: data?.voucher?.to_account?.name,
        currency: data?.voucher?.to_account?.currency,
      });
      setSelectedWalletFrom({
        id: data?.voucher?.from_account?.id,
        name: data?.voucher?.from_account?.name,
        currency: data?.voucher?.from_account?.currency,
      });
      setSelectedWalletType({
        id: data.voucher.wallet_type,
        name:
          data.voucher.wallet_type === "shipping to shipping"
            ? "Shipping to Shipping"
            : data.voucher.wallet_type === "vehicle to vehicle"
              ? "Vehicle to Vehicle"
              : data.voucher.wallet_type === "shipping to vehicle"
                ? "Shipping to Vehicle"
                : "Vehicle to Shipping",
      });
      setSelectedBankCashType({
        id: fromCashType,
        name: getCashTypeName(fromCashType),
      });
      setSelectedBankCashType2({
        id: toCashType,
        name: getCashTypeName(toCashType),
      });

      setValue("walletType", data?.voucher?.wallet_type);
      // setValue("bankType", data?.voucher?.)
      setValue("walletFrom", {
        id: data?.voucher?.from_account?.id,
        name: data?.voucher?.from_account?.name,
      });
      setValue("walletTo", {
        id: data?.voucher?.to_account?.id,
        name: data?.voucher?.to_account?.name,
      });
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  // *For Create Vehicle Booking
  const updateIftv = async (formData) => {
    setLoading(true);
    try {
      // if (selectedFromAccount?.id === selectedToAccount?.id) {
      //   ErrorToaster("Transfer account and Receiver account is same");
      //   return;
      // }

      let fromAccount = null;
      let toAccount = null;
      let cashier = false;

      if (selectedTransactionType?.name === "Wallet") {
        fromAccount = walletAccounts?.find(
          (account) => account.id === selectedWalletFrom?.id,
        );
        toAccount = walletAccounts?.find(
          (account) => account.id === selectedWalletTo?.id,
        );
      } else if (selectedTransactionType?.name === "Cash/Bank") {
        if (
          selectedBankCashType?.id === "bank guc" ||
          selectedBankCashType?.id === "bank gws"
        ) {
          fromAccount = bankAccounts?.find(
            (account) => account.id === selectedBankCashFrom?.id,
          );
        } else if (
          selectedBankCashType?.id === "cash guc" ||
          selectedBankCashType?.id === "cash gws"
        ) {
          fromAccount = cashierAccounts?.find(
            (account) => account.id === selectedBankCashFrom?.id,
          );
        }

        if (
          selectedBankCashType2?.id === "bank guc" ||
          selectedBankCashType2?.id === "bank gws"
        ) {
          toAccount = bankAccounts?.find(
            (account) => account.id === selectedBankCashTo?.id,
          );
        } else if (
          selectedBankCashType2?.id === "cash guc" ||
          selectedBankCashType2?.id === "cash gws"
        ) {
          toAccount = cashierAccounts?.find(
            (account) => account.id === selectedBankCashTo?.id,
          );
        }
      }

      if (selectedTransactionType?.id === "cash/bank") {
        const fromIsCash = (selectedBankCashType?.id || "").startsWith("cash");
        const toIsCash = (selectedBankCashType2?.id || "").startsWith("cash");
        cashier = fromIsCash || toIsCash;
      } else {
        cashier = false;
      }
      const isWallet = selectedTransactionType?.id === "wallet";
      const normalizedExchangeRate = normalizeExchangeRate(
        updateExchangeRate ?? formData?.exchangeRate,
        getStandardUsdRate(),
      );
      let obj = {
        voucher_id: parseInt(id),
        from_account_id: isWallet
          ? selectedWalletFrom?.id
          : selectedBankCashFrom?.id,
        to_account_id: isWallet ? selectedWalletTo?.id : selectedBankCashTo?.id,
        from_currency: fromAccount?.currency ?? selectedBankCashFrom?.currency ?? selectedWalletFrom?.currency,
        from_amount: parseFloat(formData?.transferAmount)?.toFixed(2),
        to_currency: toAccount?.currency,
        to_amount: parseFloat(formData?.receivedAmount)?.toFixed(2),
        to_amount_aed: parseFloat(formData?.receivedAmountAed || 0)?.toFixed(2),
        exchange_rate: normalizedExchangeRate,
        exchange_loss: parseFloat(formData.exchangeLoss)?.toFixed(2),
        ref_no: formData.ref,
        notes: formData.note,
        cashier: cashier,
        date: iftvDate,
        document_link: documentLink2,
        document_name: documentName,
        transaction_type: selectedTransactionType?.id,
        wallet_type: selectedWalletType?.id,
        new_voucher: true,
        from_cash_type: selectedBankCashType?.id,
        to_cash_type: selectedBankCashType2?.id,
        bank_cash_type: selectedBankCashType?.id,
        cash_bank_type: selectedBankCashType2?.id,
      };
      const result = await FinanceServices.editFundTransferVoucher(obj);

      if (
        result?.status === true &&
        result?.responseCode === 200 &&
        result?.data?.id
      ) {
        const voucher_id = result?.data?.id;

        const params = { voucher_id };

        // 1) Fetch full invoice list
        const { data } =
          await FinanceServices.getFundTransferVoucherDetail(params);

        if (!data) {
          console.log("No record found to upload");
          return;
        }

        // 2) Generate PDFs
        const uploadFiles = [];

        const file = await new Promise((resolve, reject) => {
          try {
            const container = document.createElement("div");
            container.style.position = "absolute";
            container.style.top = "-99999px";
            container.style.left = "-99999px";
            container.style.width = "1200px";
            document.body.appendChild(container);

            const root = createRoot(container);

            const handleDone = (pdfBlob) => {
              setTimeout(() => {
                try {
                  root.unmount();
                  container.remove();
                } catch {}
                resolve(pdfBlob);
              }, 200);
            };

            root.render(
              <FundTransferVoucherInvoice
                voucherDetail={data?.voucher}
                onDone={handleDone}
              />,
            );
          } catch (err) {
            console.error("❌ PDF Generation Error", err);
            reject(err);
          }
        });

        const pdfFile =
          file instanceof Blob
            ? new File([file], `iftvVoucher-GWS-IFTV-${voucher_id}.pdf`, {
                type: "application/pdf",
              })
            : null;

        uploadFiles.push({
          voucher_id: voucher_id,
          file: pdfFile,
        });

        // 3) Upload PDFs
        const formData = new FormData();
        formData.append("invoice_type", "iftvVoucher");

        uploadFiles.forEach((file, index) => {
          formData.append(`iftv_voucher[${index}][voucher_id]`, voucher_id);
          formData.append(`iftv_voucher[${index}][file]`, file.file);
        });

        await SystemServices.uploadERPInvoices(formData);

        setLoading(false);
        SuccessToaster(result.message);
        navigate("/fund-transfer-vouchers");
      }
      setLoading(false);
      SuccessToaster(result.message);
      navigate("/fund-transfer-vouchers");
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedWalletType) {
      switch (selectedWalletType?.id) {
        case "vehicle to vehicle":
          setFilteredWalletFromAccounts(
            vaultAccounts.filter((account) => account.name.startsWith("GVV")),
          );
          setFilteredWalletToAccounts(
            vaultAccounts.filter((account) => account.name.startsWith("GVV")),
          );
          break;
        case "vehicle to shipping":
          setFilteredWalletFromAccounts(
            vaultAccounts.filter((account) => account.name.startsWith("GVV")),
          );
          setFilteredWalletToAccounts(
            vaultAccounts.filter((account) => account.name.startsWith("GSV")),
          );
          break;
        case "shipping to shipping":
          setFilteredWalletFromAccounts(
            vaultAccounts.filter((account) => account.name.startsWith("GSV")),
          );
          setFilteredWalletToAccounts(
            vaultAccounts.filter((account) => account.name.startsWith("GSV")),
          );
          break;
        case "shipping to vehicle":
          setFilteredWalletFromAccounts(
            vaultAccounts.filter((account) => account.name.startsWith("GSV")),
          );
          setFilteredWalletToAccounts(
            vaultAccounts.filter((account) => account.name.startsWith("GVV")),
          );
          break;
        default:
          setFilteredWalletFromAccounts([]);
          setFilteredWalletToAccounts([]);
      }
    }
  }, [selectedWalletType, vaultAccounts]);

  return (
    <Box
      className="your-component-container"
      sx={{
        m: 4,
        p: 5,
      }}
    >
      {loader && (
        <div className="bookingoverlay">
          {" "}
          <CircularProgress />{" "}
        </div>
      )}

      <Box component="form" onSubmit={handleSubmit(updateIftv)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Typography
              variant="h5"
              sx={{
                fontFamily: "Helvetica",
                fontSize: "27px",
                fontWeight: 700,
                fontStyle: "Bold",
              }}
            >
              Update IFTV
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={2} sx={{ mt: 0 }}>
              <Grid item xs={12} sm={4}>
                <SelectField
                  label={"Transaction Type:"}
                  options={[
                    {
                      id: "cash/bank",
                      name: "Cash/Bank",
                    },
                    {
                      id: "wallet",
                      name: "Wallet",
                    },
                  ]}
                  selected={selectedTransactionType}
                  onSelect={(value) => {
                    setSelectedTransactionType(value);
                    if (value.id === "cash/bank") {
                      setDisabledExchangeRate(false);
                      setUpdateExchangeRate(exchangeRateUsd);
                      setValue("exchangeRate", exchangeRateUsd);
                    } else {
                      setUpdateExchangeRate(exchangeRateUsd);
                      setDisabledExchangeRate(true);
                      setValue("exchangeRate", exchangeRateUsd);
                    }
                  }}
                  error={errors?.customer?.message}
                  register={register("transType", {
                    required: "Please select transaction type.",
                  })}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DatePicker
                  label={"Date*"}
                  value={iftvDate}
                  error={errors?.iftvDate?.message}
                  register={register("iftvDate", {
                    // required: "Please select iftv date",
                  })}
                  onChange={(date) => handleIftvDate(date)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <InputField
                  label={"REFERENCE NO*"}
                  placeholder={"Enter Reference No"}
                  register={register("ref")}
                />
              </Grid>

              {selectedTransactionType?.name === "Wallet" && (
                <>
                  <Grid item xs={12} sm={12}>
                    <Typography
                      sx={{
                        fontSize: "20px",
                        fontFamily: "Helvetica",
                        fontWeight: 700,
                        fontStyle: "Bold",
                      }}
                    >
                      Select Payment Type
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <SelectField
                      label={"Wallet Type"}
                      options={[
                        {
                          id: "vehicle to vehicle",
                          name: "Vehicle to Vehicle",
                        },
                        {
                          id: "shipping to shipping",
                          name: "Shipping to Shipping",
                        },
                        {
                          id: "vehicle to shipping",
                          name: "Vehicle to Shipping",
                        },
                        {
                          id: "shipping to vehicle",
                          name: "Shipping to Vehicle",
                        },
                      ]}
                      selected={selectedWalletType}
                      onSelect={(value) => {
                        setSelectedWalletType(value);
                        setSelectedWalletFrom("");
                        setSelectedWalletTo("");
                      }}
                      error={errors?.walletType?.message}
                      register={register("walletType", {
                        required: "Please select wallet type.",
                      })}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <SelectField
                      label={"From"}
                      options={filteredWalletFromAccounts}
                      selected={selectedWalletFrom}
                      onSelect={(value) => {
                        setSelectedWalletFrom(value);
                      }}
                      error={errors?.walletFrom?.message}
                      register={register("walletFrom", {
                        required: "Please select wallet type.",
                      })}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <SelectField
                      label={"To"}
                      options={filteredWalletToAccounts}
                      selected={selectedWalletTo}
                      onSelect={(value) => {
                        setSelectedWalletTo(value);
                      }}
                      error={errors?.walletTo?.message}
                      register={register("walletTo", {
                        required: "Please select wallet type.",
                      })}
                    />
                  </Grid>
                </>
              )}

              {selectedTransactionType?.name === "Cash/Bank" && (
                <>
                  <Grid item xs={12} sm={12}>
                    <Typography
                      sx={{
                        fontSize: "20px",
                        fontFamily: "Helvetica",
                        fontWeight: 700,
                        fontStyle: "Bold",
                      }}
                    >
                      Select Payment Type
                    </Typography>
                  </Grid>
                  <Grid container spacing={2} sx={{ mt: 0 }}>
                    <Grid item xs={5} sm={5}>
                      <Grid item xs={12} sm={9} sx={{ ml: 2 }}>
                        <SelectField
                          label={"Cash/Bank"}
                          options={[
                            {
                              id: "bank guc",
                              name: "Bank GUC",
                            },
                            {
                              id: "bank gws",
                              name: "Bank GWS",
                            },
                            {
                              id: "cash guc",
                              name: "Cash GUC",
                            },
                            {
                              id: "cash gws",
                              name: "Cash GWS",
                            },
                          ]}
                          selected={selectedBankCashType}
                          onSelect={(value) => {
                            setSelectedBankCashType(value);
                            setSelectedBankCashFrom("");
                          }}
                          error={errors?.bankType?.message}
                          register={register("bankType", {
                            required: "Please select cash bank type.",
                          })}
                        />
                      </Grid>

                      <Grid item xs={12} sm={9} sx={{ ml: 2 }}>
                        <SelectField
                          label={"From"}
                          options={filteredFromAccounts}
                          selected={selectedBankCashFrom}
                          onSelect={(value) => {
                            setSelectedBankCashFrom(value);
                          }}
                          error={errors?.walletFrom?.message}
                          register={register("walletFrom", {
                            required: "Please select wallet type.",
                          })}
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={1} sx={{ display: "flex" }}>
                      <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ borderColor: "#B3B3B3" }}
                      />
                    </Grid>

                    <Grid item xs={5} sm={5}>
                      <Grid item xs={12} sm={8}>
                        <SelectField
                          label={"Cash/Bank"}
                          options={[
                            {
                              id: "bank guc",
                              name: "Bank GUC",
                            },
                            {
                              id: "bank gws",
                              name: "Bank GWS",
                            },
                            {
                              id: "cash guc",
                              name: "Cash GUC",
                            },
                            {
                              id: "cash gws",
                              name: "Cash GWS",
                            },
                          ]}
                          selected={selectedBankCashType2}
                          onSelect={(value) => {
                            setSelectedBankCashType2(value);
                            setSelectedBankCashTo("");
                          }}
                          error={errors?.bankType2?.message}
                          register={register("bankType2", {
                            required: "Please select cash bank type.",
                          })}
                        />
                      </Grid>

                      <Grid item xs={12} sm={8}>
                        <SelectField
                          label={"To"}
                          options={filteredToAccounts}
                          selected={selectedBankCashTo}
                          onSelect={(value) => {
                            setSelectedBankCashTo(value);
                          }}
                          error={errors?.walletTo?.message}
                          register={register("walletTo", {
                            required: "Please select wallet type.",
                          })}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            {selectedTransactionType?.name === "Wallet" ? (
              <>
                <Grid item xs={12} sm={12}>
                  <Typography
                    sx={{
                      fontSize: "20px",
                      fontFamily: "Helvetica",
                      fontWeight: 700,
                      fontStyle: "Bold",
                    }}
                  >
                    Add Amount Details $
                  </Typography>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} sm={12}>
                  <Typography
                    sx={{
                      fontSize: "20px",
                      fontFamily: "Helvetica",
                      fontWeight: 700,
                      fontStyle: "Bold",
                    }}
                  >
                    Add Amount Details
                  </Typography>
                </Grid>
              </>
            )}

            <Grid item xs={12} sm={4}>
              <InputField
                size={"small"}
                label={"Transfer Amount"}
                placeholder={"Amount"}
                error={errors?.transferAmount?.message}
                register={register("transferAmount", {
                  required: "Please enter transfer amount",
                  onChange: (e) => {
                    const priceAmount = e.target.value;
                    if (
                      !(
                        !priceAmount ||
                        priceAmount.match(/^\d{1,}(\.\d{0,2})?$/)
                      )
                    ) {
                      setValue(
                        "transferAmount",
                        parseFloat(getValues("transferAmount")).toFixed(2),
                      );
                    }
                    setTransferAmount(e.target.value);
                    setRcvAmountAed(e.target.value * exchangeRateUsd);
                  },
                })}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <InputField
                disabled={true}
                size={"small"}
                label={"Received Amount"}
                placeholder={"Received Amount"}
                register={register("receivedAmount")}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <InputField
                error={errors?.exchangeRate?.message}
                disabled={disabledExchangeRate}
                size={"small"}
                label={"Exchange Rate"}
                placeholder={"Exchange Rate"}
                defaultValue={String(updateExchangeRate)}
                register={register("exchangeRate", {
                  validate: (value) =>
                    Number(value) > 0 || "Exchange rate must be greater than 0",
                  onChange: (e) => {
                    if (!disabledExchangeRate) {
                      setUpdateExchangeRate(e.target.value);
                    }
                  },
                  onBlur: (e) => {
                    if (!disabledExchangeRate) {
                      syncExchangeRateValue(e.target.value);
                    }
                  },
                })}
              />
            </Grid>
            {selectedTransactionType?.id === "wallet" ? (
              <>
                <Grid item xs={12} sm={4}>
                  <InputField
                    // disabled={true}
                    size={"small"}
                    label={"Received Amount(AED)"}
                    placeholder={"Received Amount(AED)"}
                    value={parseFloat(rcvAmountAed).toFixed(2)}
                    inputProps={{ readOnly: true }}
                    register={register("receivedAmountAed")}
                  />
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} sm={4}>
                  <InputField
                    disabled={true}
                    size={"small"}
                    label={"Exchange Loss"}
                    placeholder={"Exchange Gain/Loss"}
                    register={register("exchangeLoss")}
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12} sm={8}>
              <InputField
                label={"Note"}
                placeholder={"Add Note..."}
                register={register("note")}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            {/* <Grid item xs={12} sm={3}>
                            <SelectField
                                label="Attachment Type"
                                options={[{
                                    id: 1, name: "doc1"
                                }, {
                                    id: 2, name: "doc2"

                                }]}
                                selected={attachmentType}
                                onSelect={(value) => {
                                    setAttachmentType(value);

                                }}
                                // error={errors?.attachmentType?.message}
                                register={register("attachmentType", {
                                    // required: "Please select invoice.",
                                })}
                            />

                        </Grid> */}

            <Grid item xs={12} sm={3} mt={3.7}>
              <UploadFile
                custom={true}
                vendor={true}
                style={{
                  backgroundColor: "#e7efeb",
                  width: "100%",
                  height: "40px",
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "20px",
                  border: "1px dashed #aeb1b0",
                  borderRadius: "10px",
                }}
                register={register("scanned", {
                  onChange: (e) => handleUploadDocumentInvoices(e),
                })}
              />
            </Grid>
            {/* <Grid item xs={12} sm={1} sx={{ textAlign: "right" }} mt={4}>
                            <IconButton
                                size="small"
                                onClick={handleAddDocument}
                                sx={{
                                    bgcolor: Colors.primary,
                                    color: Colors.white,
                                    "&:hover": {
                                        bgcolor: Colors.primary,
                                        color: Colors.white,
                                    },
                                }}
                            >
                                <Add />
                            </IconButton>
                        </Grid> */}

            {documentLink2 && (
              <>
                <Grid item xs={12} sm={12}>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="Documents Table">
                      <TableHead
                        sx={{ bgcolor: Colors.primary, color: Colors.white }}
                      >
                        <TableRow>
                          <Cell>File Name</Cell>
                          <Cell>Attachment</Cell>
                          {/* <Cell>Action</Cell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {/* {invoiceList.map((doc) => ( */}
                        <TableRow>
                          <TableCell>{documentName ?? "-"}</TableCell>
                          <TableCell>
                            {documentLink2 ? (
                              <div
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  downloadAllAttachments(documentLink2)
                                }
                              >
                                <FiDownload color={Colors.primary} size={25} />
                              </div>
                            ) : (
                              <FiDownload color="gray" size={25} />
                            )}
                          </TableCell>
                          {/* <TableCell>
                                                                <IconButton
                                                                    aria-label="delete document"
                                                                    onClick={() => handleDeleteDocument(doc.id)}
                                                                    sx={{ color: Colors.danger }}
                                                                >
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </TableCell> */}
                        </TableRow>
                        {/* ))} */}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </>
              //     ) : (
              //         <>
              //         </>
            )}
          </Grid>
        </Grid>
        {/* <Grid item xs={12} ml={2} mr={2}>
                    <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
                </Grid> */}

        {/* Sticky footer submit */}
        <Box
          sx={{
            bottom: 0,
            pt: 2,
            mt: 2,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <PrimaryButton title="Update" type="submit" loading={loading} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default UpdateIftv;
